import BaseSwitch from "@reusables/BaseSwitch";
import BaseTooltip from "@reusables/BaseTooltip";
import { cn } from "@helpers/utils";
import { Stack } from "@mui/material";
import { useTranslation } from "react-i18next";
import { ReactComponent as QuestionSVG } from "@assets/icons/ic_question.svg";

type IsWebProductToggleProps = {
    checked: boolean;
    disabled?: boolean;
    onChange: (value: boolean) => void;
    className?: string;
};

export default function IsWebProductToggle(props: IsWebProductToggleProps) {
    const { t } = useTranslation("", { keyPrefix: "products.general.fields.isWebProduct" });

    return (
        <Stack
            direction={"row"}
            spacing={1}
            alignItems={"center"}
            className={cn(
                "group h-[44px] px-[16px] py-[8px] rounded-[8px] border-[1px] border-solid " +
                    "border-inputs-border-default !bg-opacity-30 transition-[.25s] select-none",
                props.disabled ? "cursor-default" : "cursor-pointer hover:bg-inputs-border-default",
                props.checked && "border-purple-400",
                props.className
            )}
            onClick={() => {
                if (!props.disabled) {
                    props.onChange(!props.checked);
                }
            }}
        >
            <BaseSwitch
                checked={props.checked}
                onChange={(_, checked) => props.onChange(checked)}
                disabled={props.disabled}
            />
            <div className="flex items-center">
                <span>{t("label")}</span>
                <div
                    className="ml-[8px] flex items-center"
                    onClick={(event) => event.stopPropagation()}
                >
                    <BaseTooltip title={`${t("tip")}`} placement="top">
                        <QuestionSVG className="text-specialIcons-question transition-colors group-hover:text-purple-400" />
                    </BaseTooltip>
                </div>
            </div>
        </Stack>
    );
}
